
var MD5 = require("crypto-js/md5");
// var config = require("../../../config");
// console.log(config);

var mtaInit = function (url , appID, appKey) {
    var timestamp = getTimestamp();
    var query = {
        ai: appID,
        ac: "",
        av: "1.0.0",
        r: getResolution(),
        o: 0,
        nt: getNetType(),
        cp: location.pathname,
        et: 0,
        ej: "",
        //   ui: (this.user.id || '').toString(),
        //   sex: this.user.sex || 0,
        ui: "",
        sex: "",
        ts: timestamp,
        sn: getSignature(appID, appKey, timestamp),
    };
    postData(url + "/report/log/pce", query);

    // 页面首次加载
    window.addEventListener("load", () => {
        console.log("页面加载完成");
    });

    // 页面关闭或刷新前
    window.addEventListener("beforeunload", (e) => {
        console.log("页面即将关闭");
        postData(url + "/report/log/pce", query);

        // 可阻止默认行为（需谨慎使用）
        // e.preventDefault();
    });
};
function getResolution() {
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    return `${screenWidth}x${screenHeight}`;
}
function getNetType() {
    var ua = navigator.userAgent;
    var netType = String(ua.match(/NetType\/\w+/)).toLowerCase();
    var nt = 0;
    if (netType.includes("4g")) {
        nt = 4;
    } else if (netType.includes("3g")) {
        nt = 3;
    } else if (netType.includes("2g")) {
        nt = 2;
    } else if (netType.includes("wifi")) {
        nt = 1;
    }
    return nt;
}
function getTimestamp() {
    return Date.now();
}
function getSignature(siteId, siteKey, timestamp) {
    var queryString = `app_id=${siteId}&timestamp=${timestamp}&app_secret=${siteKey}`;
    var sign = MD5(queryString).toString();
    return sign;
}
function getQueryString(query) {
    return Object.entries(query)
        .map(([k, v]) => `${k}=${v}`)
        .join("&");
}
function postData(url, query) {
    var queryString = getQueryString(query);
    url = url + (queryString ? `?${queryString}` : "");

    if (navigator.sendBeacon) {
        navigator.sendBeacon(url); // Chrome 39+, Safari 11.1+, Firefox 31+, Edge 14+
        // TODO: fetch(url, { keepalive: true, credentials: 'include' }); // Chrome 66+, Safari 23+,   FireFox ---, Edge 15+
    } else {
        var image = new Image();
        image.src = url;
    }
}
module.exports = mtaInit;
